var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocCallOffIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11867_18092",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11867_18092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 26V24H27V26H14ZM15 23C15 21.65 15.425 20.4708 16.275 19.4625C17.125 18.4542 18.2 17.8333 19.5 17.6V16.975C19.5 16.6917 19.5958 16.4542 19.7875 16.2625C19.9792 16.0708 20.2167 15.975 20.5 15.975C20.7833 15.975 21.0208 16.0708 21.2125 16.2625C21.4042 16.4542 21.5 16.6917 21.5 16.975V17.6C22.7833 17.8333 23.8542 18.4542 24.7125 19.4625C25.5708 20.4708 26 21.65 26 23H15ZM17.625 20.975H23.325C23.0083 20.525 22.6042 20.1625 22.1125 19.8875C21.6208 19.6125 21.0833 19.475 20.5 19.475C19.9 19.475 19.35 19.6125 18.85 19.8875C18.35 20.1625 17.9417 20.525 17.625 20.975ZM5 17V6H11V7.45L18 5.5L26 8V9C26 9.83333 25.7083 10.5417 25.125 11.125C24.5417 11.7083 23.8333 12 23 12H21V12.6C21 13.0167 20.8792 13.3958 20.6375 13.7375C20.3958 14.0792 20.0833 14.325 19.7 14.475L12.95 17H5ZM7 15H9V8H7V15ZM11 15H12.6L18.4 12.875C18.5833 12.8083 18.7292 12.6958 18.8375 12.5375C18.9458 12.3792 19 12.2 19 12H17.225L14.3 12.95L13.7 11.05L16.825 10H23C23.15 10 23.3375 9.94583 23.5625 9.8375C23.7875 9.72917 23.9 9.6 23.9 9.45L17.95 7.6L11 9.5V15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocCallOffIcon);
export default __webpack_public_path__ + "static/media/DocCallOffIcon.81414f048e7f1588c6373c998d93bbb2.svg";
export { ForwardRef as ReactComponent };